module.exports = __webpack_public_path__ + "media/images/aspirant-529866635e4fcb1fb42ba5ce2922369b.png";